import { useReferenceRendering } from "src/base-components/Chat/ChatReferences";
import { InlineReference } from "src/base-components/Chat/PromptBox/InlineReference";
import { parseReferenceAttributes } from "src/base-components/Chat/PromptBox/mentionContent";

type Props = React.HTMLAttributes<HTMLElement> & {
  "data-reference"?: string;
};

/**
 * Renders a `<reference .../>` tag inside message markdown as inline text
 * with the kind's icon, using the `ChatReferencesProvider` config.
 */
export const TktlReference: React.FC<Props> = ({
  "data-reference": raw,
  children,
}) => {
  const { kinds } = useReferenceRendering();
  const attrs = parseReferenceAttributes(raw ?? "");
  if (!attrs.id || !attrs.label) {
    return <>{children}</>;
  }
  const { label, ...rest } = attrs;
  return <InlineReference attrs={rest} kinds={kinds} label={label} />;
};
